import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { VtigerService } from '../api/api';

@Component({
  selector: 'app-registro-modal',
  templateUrl: './registro-modal.component.html',
  styleUrls: ['./registro-modal.component.scss'],
})
export class RegistroModalComponent implements OnInit {
  @Input() contacto: any;
  registroForm: FormGroup;
  @Output() contactoCreado = new EventEmitter<number>();

  constructor(
    private fb: FormBuilder,
    private modalController: ModalController,
    private api: VtigerService
  ) {
    this.registroForm = this.fb.group({
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      correo: ['', [Validators.required, Validators.email]],
      nacionalidad: [''],
      cedula: ['', Validators.required],
      genero: ['Varón'],
      direccion: [''],
      telefono: [''],
      celular: ['']
    });
  }

  ngOnInit() {
    console.log("---------",this.contacto);
    if (this.contacto) {
      this.registroForm.patchValue({
        nombre: this.contacto.firstname,
        apellido: this.contacto.lastname,
        correo: this.contacto.email,
        nacionalidad: this.contacto.cn_nacionalidad || '',
        cedula: this.contacto.cn_documento,
        genero: this.contacto.cn_genero || 'Varón',
        direccion: this.contacto.mailingstreet || '',
        telefono: this.contacto.phone || '',
        celular: this.contacto.mobile
      });
    }
  }

  async register() {
    const entity = {
      id: this.contacto?.id || '',
      firstname: this.registroForm.value.nombre,
      lastname: this.registroForm.value.apellido,
      email: this.registroForm.value.correo,
      cn_nacionalidad: this.registroForm.value.nacionalidad || "NO TIENE",
      cn_documento: this.registroForm.value.cedula,
      mailingstreet: this.registroForm.value.direccion || "",
      phone: this.registroForm.value.telefono || "",
      mobile: this.registroForm.value.celular,
      cn_genero: this.registroForm.value.genero,
      assigned_user_id: 6
    };

    try {
      let res: any;
      let id 
      if (this.contacto) {
        res = await this.api.revise(entity);
        id = this.contacto?.id
      } else {
        res = await this.api.create('Contacts', entity);
        id =  res.result.id
      }
      console.log(res);
      if (res.success) {
        const pr_persona = {
          id: id,
          label: `${entity.firstname} ${entity.lastname}`
        };

        this.modalController.dismiss(pr_persona);
      }
    } catch (error) {
      console.error('Error al registrar el contacto:', error);
    }
  }

  dismiss() {
    this.modalController.dismiss();
  }

  cancel() {
    this.dismiss();
  }

   // Función para limitar la longitud de los campos
   limitarLongitudCampo(campo: string, maxLength: number) {
    const control = this.registroForm.get(campo);
    if (control.value && control.value.length > maxLength) {
      control.setValue(control.value.substr(0, maxLength));
    }
  }

  // Función para permitir solo números
  permitirSoloNumeros(event: any) {
    const inputChar = String.fromCharCode(event.charCode);
    if (!/^\d+$/.test(inputChar)) {
      event.preventDefault();
    }
  }
}
